"use client";

import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      position="top-center"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-grey-900 group-[.toaster]:border-grey-200 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-grey-600",
          actionButton: "group-[.toast]:bg-green-300 group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-grey-100 group-[.toast]:text-grey-600",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
